const setupShowMore = (collectionContainer) => {
  const showStep = Number(collectionContainer.dataset.showStep || 6);
  const initialVisible = showStep;
  const wrapper = collectionContainer.closest('.it-collection-wrapper');
  const items = Array.from(collectionContainer.querySelectorAll('[data-collection-item]'));
  const showMoreButton = wrapper?.querySelector('.js-mir-collection-show-more');
  let visibleCount = Math.min(initialVisible, items.length);

  const updateVisibleItems = () => {
    items.forEach((item, index) => {
      item.classList.toggle('d-none', index >= visibleCount);
    });
    if (showMoreButton) {
      showMoreButton.classList.toggle('d-none', visibleCount >= items.length);
    }
  };

  showMoreButton?.addEventListener('click', () => {
    visibleCount = Math.min(items.length, visibleCount + showStep);
    updateVisibleItems();
  });

  updateVisibleItems();
};

const setupCollection = (collectionContainer) => {
  setupShowMore(collectionContainer);
};

const bootstrapCollections = () => {
  const collections = document.querySelectorAll('.js-mir-collection');
  collections.forEach((collection) => setupCollection(collection));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapCollections);
} else {
  bootstrapCollections();
}
